export default Object.freeze({
    TODO: 'toDo',
    IN_PROGRESS: 'inProgress',
    PENDING: 'pending',
    LATE: 'late',
    COMPLETED: 'completed',
});
